// import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';

/*
  Generated class for the ToastHelperProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ToastHelperProvider {

  constructor(private toastCtrl: ToastController) {
  }
  showToast(msg, type = "success"){
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'middle',
      cssClass: type + ' toast-under-nav',
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/toast-helper/toast-helper.ts